import React, { useState } from "react"
import { useRecoilValue } from "recoil"
import { notificationsState } from "./StateSelectors"
import DOMPurify from "dompurify"

const Notifications = () => {
  const notifications = useRecoilValue(notificationsState)
  const [n_index, setN_index] = useState<string[]>([])

  const clear_expired_notification = () => {
    let results = []
    for (let i = 0; i < localStorage.length; i++) {
      let key = localStorage.key(i)
      if (key?.startsWith("notification")) {
        results.push(localStorage.getItem(key))
      }
    }
    results.forEach((element) => {
      const item = JSON.parse(element!)
      const now = new Date()
      if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage and return
        localStorage.removeItem("notification" + item.value)
        return
      }
    })
  }

  if (localStorage.length > 0) {
    clear_expired_notification()
  }

  // check if there is cookies related to notifications
  const cookies_data: string[] = []
  notifications?.forEach((element) => {
    let cookie = localStorage.getItem("notification" + element.guid)
    if (cookie) {
      const item = JSON.parse(cookie)
      cookies_data.push(item.value)
    }
  })

  const handleCloseNotification = (i: string) => {
    setN_index((oldArray) => [...oldArray, i])
    setCookies(i)
  }

  const setCookies = (i: string) => {
    const now = new Date()
    const item = {
      value: i,
      expiry: now.getTime() + 1000 * 60 * 60 * 24 * 7 //expires after 7 days
    }
    localStorage.setItem("notification" + i, JSON.stringify(item))
  }

  return (
    <div>
      {notifications &&
        notifications!.length > 0 &&
        notifications!.map((n) => (
          <div
            className="notifications"
            key={n.guid}
            style={{
              display: cookies_data.includes(n.guid) || n_index.includes(n.guid) ? "none" : "block"
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div style={{ marginRight: "2.5rem" }}>
                <h6 style={{ marginBottom: "5px" }}>{n.title}</h6>
                <p>
                  {
                    <div
                      className="notificationbody"
                      // show as sanitized html (allow target="_blank" to open links in new tab)
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(n.description, { ADD_ATTR: ["target"] }) }}
                    />
                  }
                </p>
              </div>
              <div onClick={() => handleCloseNotification(n.guid)} style={{ cursor: "pointer" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  className="mi-outline mi-close"
                  viewBox="0 0 24 24"
                >
                  <path d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.6 7.11 5.71A.996.996 0 1 0 5.7 7.12l4.89 4.89L5.7 16.9a.996.996 0 1 0 1.41 1.41L12 13.42l4.89 4.89a.996.996 0 1 0 1.41-1.41l-4.89-4.89 4.89-4.89a.996.996 0 0 0 0-1.41Z" />
                </svg>
              </div>
            </div>
          </div>
        ))}
    </div>
  )
}

export default Notifications
